import React from 'react';
import StrengthsAndWeaknesses from 'components/manager-dashboard/strengths-and-weaknesses/StrengthsAndWeaknesses';
import ManagerStrengthsAndWeaknesses from 'components/dashboard/manager/ManagerStrengthsAndWeaknesses';
import ManagerRecommendedCoaching, {
  getCoachingRecommendations,
  widgetId,
} from 'components/dashboard/manager/ManagerRecommendedCoaching';
import './ManagerRepSkills.styl';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';

export default class ManagerRepSkills extends React.Component {
  render() {
    return (
      <div className="standalone-widget-wrapper manager-rep-skills-wrapper">
        <ManagerStrengthsAndWeaknesses
          {...this.props}
          child={StrengthsAndWeaknesses}
          useTeam={true}
          widgetId="strengths_and_weakness_rep_dashv2"
          widgetType="REP_SCORECARDS"
        />
        <ManagerRecommendedCoaching
          {...this.props}
          refreshCoachingData={() => {
            UpcomingReviewsActions.upcomingReviews.defer(
              this.props.managerId,
              UPCOMING_REVIEW_ROLES.COACH,
              undefined,
              undefined,
              null /* reviewId */,
              null /* teamId */
            );
            getCoachingRecommendations(widgetId, this.props.managerId, this.props.selectedTeam, 3);
          }}
          suppressMascotCta
        />
      </div>
    );
  }
}
